/**
 * `/borne` has two screens that matter to the gate: pairing and everything
 * else. Pure, like `~/lib/station/route`, so the one bug worth guarding
 * against (a paired tablet bouncing to pairing, or the reverse) has a test.
 * A token that the server no longer accepts is handled by the idle screen:
 * `borne.ping` → UNAUTHORIZED → clear token → pairing.
 */
export const BORNE_PATHS = {
  pairing: "/borne/appairage",
  idle: "/borne",
} as const;

export type BornePath = (typeof BORNE_PATHS)[keyof typeof BORNE_PATHS];

function normalize(pathname: string): string {
  return pathname.length > 1 && pathname.endsWith("/")
    ? pathname.slice(0, -1)
    : pathname;
}

export function borneRedirect(
  hasDeviceToken: boolean,
  pathname: string,
): BornePath | null {
  const onPairing = normalize(pathname) === BORNE_PATHS.pairing;
  if (!hasDeviceToken) return onPairing ? null : BORNE_PATHS.pairing;
  return onPairing ? BORNE_PATHS.idle : null;
}
